import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { BUSINESS } from "../data";

export default function LegalPage({ title, updated, updatedLabel = "Last updated", children }) {
  React.useEffect(() => {
    document.title = `${title} | ${BUSINESS}`;
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <div className="App" data-testid="legal-page">
      <Navbar />
      <main className="wrap py-16 md:py-24">
        <div className="max-w-3xl">
          <h1 className="font-heading font-normal text-[2.6rem] md:text-[3.6rem] leading-[1.05] text-[#172B38]">{title}</h1>
          <p className="text-[#5F676B] mt-4 text-sm">{updatedLabel}: {updated}</p>
          <div className="hw-rule mt-10" />
          <div className="prose-legal mt-10 space-y-6 text-[#3E474B] leading-relaxed">{children}</div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
